import { useBeforeUnload } from "./beforeUnReload";
import { useBlockNavigation } from "./blockNavigationPromt";
import { checkPermissions } from "./checkPermissions";
export default {
  useBeforeUnload,
  useBlockNavigation,
  checkPermissions,
};
